module.exports = __webpack_public_path__ + "assets/img/ulu pandan 59m.dc271be0.jpg";